import { VStack } from "@whoosh/design-system/src/components/primitive";

import { BookingWizard } from "../../../../types";
import { UnknownGuestCounter } from "./UnknownGuestCounter";

type GuestListHeaderProps = {
  onAddUnknownGuest: () => void;
  onRemoveUnknownGuest: () => void;
  allowUnknownGuest: boolean;
  capacityOnBooking: number;
  rounds?: BookingWizard.BaseRound[];
};

export const GuestListHeader = ({
  onAddUnknownGuest,
  onRemoveUnknownGuest,
  allowUnknownGuest = true,
  capacityOnBooking,
  rounds,
}: GuestListHeaderProps) => {
  return (
    <VStack>
      {allowUnknownGuest ? (
        <UnknownGuestCounter
          onAddUnknownGuest={onAddUnknownGuest}
          onRemoveUnknownGuest={onRemoveUnknownGuest}
          capacityOnBooking={capacityOnBooking}
          rounds={rounds}
        />
      ) : null}
    </VStack>
  );
};
